<template>
  <vx-card class="mt-base" :title="activityTitle">
    <h4 class="mb-5">Design, Build, and Test the Strongest Bridge</h4>
    <p class="mb-5">In this activity, you’ll design a bridge, build it, <i>and</i> test it.</p>
    <p class="mb-5">
      First, let’s take a look at this record-breaking bridge built way back in 2012. Don’t worry
      about the production qualities! The clip is as compelling as the camerawork is bad! But still
      well worth a watch to see just what’s possible with paddle pop sticks!
    </p>
    <responsive-youtube-wrapper :video="videos[1].video" :image="videos[1].image" />

    <h4 class="mb-5">Design Brief:</h4>
    <p class="mb-5">
      You are going to design a truss bridge that will span 450mm. It will be made entirely out of
      paddle pop sticks and wood glue.
    </p>
    <div class="vx-row w-full">
      <div class="vx-col sm:w-2/3">
        <p class="mb-5">You are going to design a truss bridge, build, and then test it.</p>
        <p class="mb-5">
          But, first you’ll need to design your truss. Click on the image on the right to open a
          sheet that shows you some different possible truss designs that you could work with.
        </p>
        <p class="mb-5">
          Sketch up 3 different drawings of your truss design (maybe from different angles and both
          2D and 3D.
        </p>
        <p class="mb-5">
          Now either scan these drawings or take photos of them and upload them below.
        </p>
      </div>
      <div class="vx-col sm:w-1/3">
        <a :href="'content/engineering/truss_bridge_designs.pdf' | blob_url" target="_blank">
          <img
            src="@/assets/images/experiences/engineering/truss_designs_buttons_small.jpg"
            alt="View the truss bridge designs (PDF, opens in a new tab)"
          />
        </a>
      </div>
    </div>

    <fileupload-button-immediate
      v-model="uploaded_files['uploaded_file_1']"
      :is-editable="isEditable"
      :upload-btn-text="'Upload Truss Design Drawing 1'"
      class="mb-5"
      filetype="photo_doc"
      index="1"
    />
    <fileupload-button-immediate
      v-model="uploaded_files['uploaded_file_2']"
      :is-editable="isEditable"
      :upload-btn-text="'Upload Truss Design Drawing 2'"
      class="mb-5"
      filetype="photo_doc"
      index="2"
    />
    <fileupload-button-immediate
      v-model="uploaded_files['uploaded_file_3']"
      :is-editable="isEditable"
      :upload-btn-text="'Upload Truss Design Drawing 3'"
      class="mb-5"
      filetype="photo_doc"
      index="3"
    />

    <div class="vx-row w-full">
      <div class="vx-col sm:w-2/3">
        <h5 class="mb-5">Now, it’s time to build your bridge.</h5>
        <p class="mb-5">You’ll Need:</p>
        <ul class="default-list mb-5">
          <li>Paddle pop sticks (as many as you can get!)</li>
          <li>Wood glue</li>
          <li>PVC piping (optional, see instructions in link below)</li>
          <li>A ruler to measure the span</li>
        </ul>
        <p class="mb-5">
          Have a look at the instructions for building a popsicle stick truss bridge by clicking on
          the image on the right:
        </p>
      </div>
      <div class="vx-col sm:w-1/3">
        <a :href="'content/engineering/paddle_pop_stick_bridge.pdf' | blob_url" target="_blank">
          <img
            src="@/assets/images/experiences/engineering/truss_bridge_designs_button.jpg"
            alt="View the instructions for building a paddle pop stick truss bridge (PDF, opens in a new tab)"
          />
        </a>
      </div>
    </div>

    <p class="mb-5">
      There’s also an interesting video of someone building a truss bridge from popsicle sticks
      using a similar method:
    </p>
    <responsive-youtube-wrapper :video="videos[2].video" :image="videos[2].image" />

    <p class="mb-5">
      When you’ve completed your bridge, take a photo or video of it and upload it below:
    </p>
    <fileupload-button-immediate
      v-model="uploaded_files['uploaded_file_4']"
      :is-editable="isEditable"
      :upload-btn-text="'Upload Bridge Design'"
      class="mb-5"
      filetype="photo_doc"
      index="4"
    />

    <p class="mb-5">
      You can also test its capacity for weight by hanging something from it, say, a bag of sugar.
    </p>
    <p class="mb-5">
      If you have scales at home, you could even test it to see how much weight it can hold
      altogether! <br />
      If you were able to measure how much weight the bridge was able to hold, record this below:
    </p>

    <div class="overflow-hidden">
      <p class="float-left py-2 pr-2">My bridge held</p>
      <text-block
        v-model="data.question1"
        :editable="isEditable"
        style="width: 100px; float: left"
        pclass="my-2"
      />
      <p class="float-left py-2 pr-2 ml-2">kg.</p>
    </div>

    <save-buttons :is-editable="isEditable" @save="save" />
  </vx-card>
</template>

<script>
import methods from '@/views/WorkExperiences/components/activity_js/methods';
import computed from '@/views/WorkExperiences/components/activity_js/computed';
import inject from '@/views/WorkExperiences/components/activity_js/inject';
export default {
  data() {
    return {
      videos: {
        1: {
          image: require('@/assets/images/experiences/engineering/uni_auckland.jpg'),
          video: 'https://www.youtube.com/embed/Z_h6gMlRf7k',
        },
        2: {
          image: require('@/assets/images/experiences/engineering/truss_bridge_design.jpg'),
          video: 'https://www.youtube.com/embed/nu-PIT_XuvM',
        },
      },
      image1: require('@/assets/images/experiences/gamesdeveloper/activity_1_1.png'),
      uploaded_files: {
        uploaded_file_1: '',
        uploaded_file_2: '',
        uploaded_file_3: '',
        uploaded_file_4: '',
      },
    };
  },
  methods: methods,
  computed: computed,
  inject: inject,
  mounted() {
    for (let i = 1; i <= 4; i++) {
      if (typeof this.data['uploaded_file_' + i] !== 'undefined') {
        this.uploaded_files['uploaded_file_' + i] = this.data['uploaded_file_' + i];
      }
    }
  },
};
</script>
